import { TimesheetCalendarSourceType } from 'api/timesheets';
import { Configuration } from 'api/timesheets/configuration/configuration';

export const getSourceTypeFromTimesheetConfig = (
  config: Configuration,
): TimesheetCalendarSourceType =>
  config.integrationMeta.googleCalendarEnabled
    ? TimesheetCalendarSourceType.GoogleCalendar
    : TimesheetCalendarSourceType.OutlookCalendar;
